import { render, staticRenderFns } from "./ClientCreateStepThree.vue?vue&type=template&id=70c58bd0&scoped=true&"
import script from "./ClientCreateStepThree.vue?vue&type=script&lang=js&"
export * from "./ClientCreateStepThree.vue?vue&type=script&lang=js&"
import style0 from "./ClientCreateStepThree.vue?vue&type=style&index=0&id=70c58bd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c58bd0",
  null
  
)

export default component.exports